import { Component, input, output } from '@angular/core';
import { FileDropComponent } from '@app/shared/components/files/file-drop/file-drop.component';
import { FileHorizontalListComponent } from '@app/shared/components/files/file-horizontal-list/file-horizontal-list.component';
import { FileInfo } from '@app/shared/types/models/files/file-info';
import { FileUploadInfo } from '@app/shared/types/models/files/file-upload-info';
import { Task } from '@app/shared/types/models/task/task.model';

/**
 * @summary Task detail Files tab — upload drop zone and horizontal file list.
 * @selector proffeo-task-details-files-tab
 */
@Component({
  selector: 'proffeo-task-details-files-tab',
  templateUrl: './task-details-files-tab.component.html',
  imports: [FileDropComponent, FileHorizontalListComponent]
})
export class TaskDetailsFilesTabComponent {
  public readonly task = input.required<Task>();
  public readonly files = input.required<FileInfo[]>();
  public readonly activeUploads = input.required<FileUploadInfo[]>();

  public readonly filesAdded = output<File[]>();
  public readonly fileDelete = output<FileInfo>();
  public readonly avatarSet = output<FileInfo>();
}
